import { Outlet } from "react-router-dom";
import { getCurrentUploadsStateList } from "../../features/gallery/state/gallerySlice";
import Alert from "../components/Alert/Alert";
import Sidebar from "../components/Sidebar/Sidebar";
import UploadBar from "../components/UploadBar/UploadBar";
import { PrivatePage } from "./PrivatePage";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { HelpDocsLighthouseWidget } from "../util/helpDocsLighthouse/HelpDocsLighthouseWidget";
import { languageConfig } from "../util/langConfig";
import { ILanguage } from "src/model/model";
import { getCurrentUser } from "src/features/profile/state/profileSlice";

export const UPLOAD_BAR_HEIGHT = "4rem";

const Layout = () => {
  const currentUploadsStateList = useSelector(getCurrentUploadsStateList);
  const currentUser = useSelector(getCurrentUser);
  const preferredLanguage = languageConfig((currentUser?.preferred_language as ILanguage)?.name);

  const animationActivated = () => {
    switch (location.pathname) {
      case "/":
      case "/courses":
      case "/learners":
      case "/team":
      case "/medias":
      case "/statistics":
      case "/profile/me":
      case "/download-client":
        return 0;
      default:
        return 1;
    }
  };

  return (
    <PrivatePage>
      <div className="fixed w-full min-h-screen">
        <div className="h-screen flex flex-col relative">
          <div className="flex w-full bg-slate-100" style={{ height: "100%" }}>
            <div className="text-center">
              <Alert />
            </div>
            <Sidebar />
            <main
              className="relative flex flex-col w-[calc(100%-8rem)]"
              style={{
                height:
                  currentUploadsStateList.length > 0 ? `calc(100% - ${UPLOAD_BAR_HEIGHT})` : "100%",
              }}
            >
              {animationActivated() === 0 ? (
                <motion.div
                  className="relative flex flex-col w-full h-full"
                  initial={{ opacity: animationActivated() }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: animationActivated(), transition: { duration: 2 } }}
                >
                  <Outlet />
                </motion.div>
              ) : (
                <Outlet />
              )}
            </main>
          </div>
          {currentUploadsStateList.length > 0 && (
            <div
              id="upload-bar-overlay"
              className={`h-[${UPLOAD_BAR_HEIGHT}] w-full bg-gray-200 fixed bottom-0 z-40 pl-[160px] 1536px:pl-40`}
            >
              <UploadBar className="h-full min-w-full" />
            </div>
          )}
        </div>
      </div>
      {currentUser?.has_accepted_cgv && (
        <HelpDocsLighthouseWidget
          widgetKey={"54ngc5956m4m95f4cbnu"}
          languageCode={preferredLanguage}
          configOverrides={{
            primary_color: "#0C1E59",
            brand: "Wixar",
          }}
        />
      )}
    </PrivatePage>
  );
};

export default Layout;
